import React from "react";
import { TrendingUp } from "lucide-react";

function money(n) {
  if (n == null) return "—";
  return typeof n === "number" ? `£${n.toLocaleString()}` : String(n);
}

export default function IncrementLog({ loading, items }) {
  if (loading) {
    return (
      <div className="space-y-2">
        {Array.from({ length: 4 }).map((_, i) => <div key={i} className="h-16 rounded-xl border border-[#00ff90]/20 bg-[#0d0d0d] animate-pulse" />)}
      </div>
    );
  }

  if (!items?.length) {
    return <p className="text-white/30 text-sm py-4 text-center italic">No increments in the selected range.</p>;
  }

  return (
    <div className="space-y-2">
      {items.map(x => {
        const diff = (x.to && x.from) ? x.to - x.from : null;
        return (
          <div key={x.id} className="rounded-xl border border-[#00ff90]/15 bg-[#0d0d0d] p-4">
            <div className="flex items-start justify-between gap-4 flex-wrap">
              <div className="min-w-0">
                <div className="flex items-center gap-2 flex-wrap mb-1">
                  <span className="text-sm font-medium text-white">{x.name}</span>
                  <span className="text-xs text-white/30">{x.role}</span>
                </div>
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="text-xs text-white/40">{money(x.from)}</span>
                  <span className="text-white/20 text-xs">→</span>
                  <span className="text-xs text-white/70 font-medium">{money(x.to)}</span>
                  {diff != null && (
                    <span className="text-xs text-[#00ff90] bg-[#00ff90]/10 border border-[#00ff90]/20 px-2 py-0.5 rounded-full">
                      +{money(diff)}
                    </span>
                  )}
                </div>
                {x.reason && <p className="text-xs text-white/30 mt-1">{x.reason}</p>}
              </div>
              <div className="text-right shrink-0">
                <div className="flex items-center gap-1 justify-end text-[#00ff90]">
                  <TrendingUp size={13} />
                  <span className="text-sm font-bold">+{x.deltaPct}%</span>
                </div>
                <p className="text-xs text-white/30 mt-0.5">{x.date}</p>
                {x.approver && <p className="text-xs text-white/20 mt-0.5">Approved by {x.approver}</p>}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}